import React, { Component } from 'react';
import getContract, {getBusoContract} from '../../services/contract';
import getTokenContract from '../../services/tokenContract'
import { ethers } from 'ethers';
import levelPrices, { id1Wallets } from '../../services/levelPrice';
import getWallet from '../../services/wallet';
import Slot from './tree/slot';
import { TransactionService } from '../../services/transactionService';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import withWrapper from '../../helpers/withWrapper';
import ImageZoom from './ImageZoom';
import Modal from './modal'; // importing the Modal component

class Dashboard extends Component {

    state = {
        userAddress: '',
        isWalletConnected: false,
        isAuthorized: false,
        isId1WalletConnected: false,
        levelBought: 0,
        recycleCount: 0,
        latestRecycleCount: 0,        
        dataLoaded: false,
        origRef: 0,
        partners: 0,
        userId: 0,
        isModalOpen: true
    };

    notify = (message) => toast(message);

    constructor(props) {
        super(props);
        const totalLevels = 3;
        const treeNodes = 7;
        let idsArray = new Array(totalLevels).fill(0).map(() => new Array(treeNodes).fill(0));
        this.state.idsWithLevels = idsArray;
        if(props.router.params.id) {
            this.state.userId = props.router.params.id;
        } else {
            this.state.userId = 1;
        }
        this.props.onSetUserId(this.state.userId);
    }

    initializeState = async (connectedWalletAddress) => {
        const contract = await getContract();
        let userId = this.state.userId;

        const totalMembers = ethers.BigNumber.from(await contract.lastIDCount()).toNumber();
        if(totalMembers < userId) {
            alert(`User with id ${userId} not found`);
            userId = 1;
        }

        const userAddress = await contract.getAddressById(userId);
        console.log(userAddress);

        const totalValueInvested = ethers.BigNumber.from(await contract.totalValueInvested()).toString();
        const userInfoResponse = await contract.userInfos(userId);
        const levelBought = ethers.BigNumber.from(userInfoResponse["levelBought"]).toNumber();
        const userTotalIncome = parseFloat(ethers.utils.formatUnits(userInfoResponse["totalIncome"], "mwei")).toFixed(2);
        
        const origRef = ethers.BigNumber.from(userInfoResponse["origRef"]).toNumber();
        const partners = ethers.BigNumber.from(userInfoResponse["partners"]).toNumber();
        
        let userWithLevels = this.state.idsWithLevels;
        try {
            const ids = await contract.getTree(userId);
            for(let i = 0; i < 3; i++) {
            // const latestRecycleCount = ethers.BigNumber.from(await contract.userBuso126LastRecycleCount(userId, i+1)).toNumber();
            ids[i].forEach((response, index) => {
                const id = ethers.BigNumber.from(response).toNumber();
                userWithLevels[i][index] = id;
              });
          }
        } catch (error) {
          console.log(error.message);
        }

        if(connectedWalletAddress?.toLowerCase() == userAddress.toLowerCase()) {
            this.setState({isAuthorized: true})
        }
        // console.log(userWithLevels);
        this.setState({ userAddress, userTotalIncome, totalMembers, totalValueInvested, origRef, partners,
                levelBought, idsWithLevels: userWithLevels, dataLoaded: true });
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        const wallet = await getWallet();
        const connectedWallet = await wallet.signer?.getAddress();
        if(!wallet.isReadOnly) {
            this.setState({isWalletConnected: true});
            if(id1Wallets.some(wallet => wallet.toLowerCase() == connectedWallet.toLowerCase())) {
                this.setState({isId1WalletConnected: true});
            }
        }

        const promise = this.initializeState(connectedWallet);
        

          await toast.promise(
            promise,
              {
                pending: 'Fetching Dashboard Data please wait...',
                success: 'Data Fetched! 👌',
                error: 'Error fetching dashboard data'
              }
          )
    }

    navigateToHome = () => {
        this.props.router.navigate("/?refid=" + this.state.userId);
    }

    handleCopy = () => {
        if (navigator.clipboard) {
            var textarea = document.createElement("textarea");
            textarea.textContent = this.state.userAddress;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                this.notify("Copied to clipboard");
            }
            catch (e) {
                document.body.removeChild(textarea);
            }
            // this.notify("Copying not supported in this dapp browser");
        } else {
            navigator.clipboard.writeText(this.state.userAddress).then(() => {
                this.notify("Copied to clipboard");
            }).catch((err) => {
                this.notify(err);
            })
        }
    }

    handleRefLinkCopy = () => {
        if (navigator.clipboard) {
            // this.notify("Copying not supported in this dapp browser");
            var textarea = document.createElement("textarea");
            textarea.textContent = 'https://psmodel.net/?refid=' + this.state.userId;
            textarea.style.position = "fixed";
            textarea.style.width = '2em';
            textarea.style.height = '2em';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand("copy");
                document.body.removeChild(textarea);
                this.notify("Copied to clipboard");
            }
            catch (e) {
                document.body.removeChild(textarea);
            }
        } else {
            navigator.clipboard.writeText('https://psmodel.net/?refid=' + this.state.userId).then(() => {
                this.notify("Copied to clipboard");
            }).catch((err) => {
                this.notify(err);
            })
        }
    }

    handleBuyLevel = async (level) => {
        const wallet = await getWallet();
        if(wallet.isReadOnly) {
            alert("Please connect your wallet");
            return;
        }
        const userBrowserAddresses = await wallet.provider.listAccounts();
        if(this.state.userAddress !== userBrowserAddresses[0]) {
            alert("You can't Buy for other person's, if its yours then connect your wallet with this ID");
            return;
        }
        try {
            var transactionService = new TransactionService(this.state.userId, this.state.userAddress);
            const buyLevelPromise = transactionService.buyLevel(level);
            await toast.promise(
                buyLevelPromise,
                {
                  pending: 'Level Upgrade in process',
                  success: 'Level Upgrade Completed! 👌',
                  error: 'Level Upgrade failed '
                }
            )
            await this.initializeState(this.state.userAddress);
        } catch (error) {
            alert(error.message);
        }
    }

    getIdClass = (id) => {
        return (id == 0) ? "bg-white-100" : "bg-white";
    }

    setModalOpen = (value) => {
        this.setState({isModalOpen: value});
    }
    
    render() { 
        return (
            <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
                <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full max-w-7xl px-4 sm:px-2 sm:pt-7.5">
                    {/* Top Panel, Matrix levels and all activies inside below div */}
                    <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                        
                        {/* Top panel of Dashboard mobile view inside below div */}
                        <div className="flex w-full items-start justify-center space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                            <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                                <div className="flex-shrink-0 relative w-30 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                                    <div className="w-35 h-16 sm:h-20 sm:w-20 rounded-full p-2">
                                        {/* <ImageZoom level={this.state.levelBought} /> */}
                                        <a href="/" className="flex flex-col items-center">
                                            <img src="/logo/logo2.png" className="light w-24 h-24 object-contain" alt="logo" />
                                        </a>
                                        <br></br>
                                    </div>
                                </div>
                                <div className="flex flex-col items-start ml-10 h-full justify-center my-auto">
                                    <div className="flex justify-center items-center mb-1 sm:mb-2.5">
                                        <h2 className="text-white font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId">
                                            ID # {this.state.userId}
                                        </h2>
                                    </div>
                                    <div className="flex flex-col items-start">
                                        <div className="flex items-center mb-3">
                                            <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                                                {(this.state.userAddress != '') ?
                                                    (this.state.userAddress.slice(0, 4) + '...' + this.state.userAddress.slice(this.state.userAddress.length - 4, this.state.userAddress.length))
                                                    : ''}
                                            </span>
                                            <button className="copyAddress" onClick={this.handleCopy}>
                                                <svg className="w-5 h-5" viewBox="0 0 20 20" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15 6.667H8.332c-.92 0-1.667.746-1.667 1.666V15c0 .92.746 1.667 1.667 1.667h6.666c.92 0 1.667-.747 1.667-1.667V8.333c0-.92-.746-1.666-1.667-1.666Z"></path>
                                                    <path clipRule="evenodd" d="M3.469 3.468A2.167 2.167 0 0 1 5 2.833h6.666A2.167 2.167 0 0 1 13.834 5v1.667a.5.5 0 0 1-1 0V5a1.167 1.167 0 0 0-1.167-1.167H5.001A1.167 1.167 0 0 0 3.834 5v6.667a1.167 1.167 0 0 0 1.167 1.166h1.666a.5.5 0 1 1 0 1H5.001a2.167 2.167 0 0 1-2.167-2.166V5c0-.575.228-1.126.635-1.532Z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                        <div className="flex justify-start w-full">
                                            <button onClick={() => this.navigateToHome()}
                                                className="px-8 py-3 rounded-lg bg-blue-600 text-white font-bold text-lg shadow-lg transition-all duration-300 hover:bg-blue-700 hover:scale-105 hover:shadow-blue-500/40 active:bg-blue-800 active:scale-95">
                                                Register
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br></br>

                        {/* Total Income Section */}
                        <div className="flex w-full mt-15 sm:mt-5 sm:px-5 justify-center">
                            <div className="flex w-full max-w-3xl justify-center">
                                <div className="flex-1 max-h-140px sm:max-w-full overflow-hidden relative flex justify-center items-end bg-black-light lg:max-w-full desktop-infoblock-chart-base efcard border">
                                    <div className="flex-shrink-0 flex flex-col p-5 desktop-infoblock-base sm:mobile-infoblock-base items-center text-center">
                                        <div className="flex items-center justify-center">
                                            <h2 className="text-white text-base sm:text-sm sm:whitespace-nowrap">Total Income</h2>
                                        </div>
                                        <span className="text-white text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                                            {this.state.userTotalIncome} USDT
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Matrix Tree Title */}
                        <div className="flex flex-wrap justify-center">
                            <div className="flex flex-col w-full flex-wrap sm:px-5">
                                <div className="flex items-center mb-1.5 sm:mb-2.5 justify-center">
                                    <div className="flex">
                                        <a className="mr-1.5 text text-white-300 sm:text-sm" href="/dashboard?user=1">
                                            <span className="hover:text-white-500"></span>
                                        </a>
                                    </div>
                                    <span className="text text-white whitespace-nowrap ml-1.5 sm:text-sm">
                                        <span className="inline sm:hidden" style={{display: 'none'}} id="levelBoughtInfo">
                                            (0 out of 3 blocks)
                                        </span>
                                    </span>
                                </div>
                                <div className="w-full">
                                    <div className="flex justify-center">
                                        <span className="text-two-half text-white font-medium mr-2 sm:text-2xl whitespace-nowrap">
                                            Matrix Tree
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Matrix Tree and Levels - CENTERED */}
                        <div className="flex overflow-hidden relative w-full flex-col rounded p-7.5 pb-5 sm:p-5 sm:pl-2.5 sm:pr-2.5 sm:rounded-none">
                            <div className="flex z-10 flex-wrap -m-2 sm:-mx-px mb-7.5 sm:justify-center justify-center">
                                {this.state.idsWithLevels.map((ids, index) => {
                                    const isActive = (index+1) <= this.state.levelBought;
                                    return (
                                        <div key={index} className="flex justify-center mx-2">
                                            <Slot 
                                                ids={ids} 
                                                index={index}
                                                levelPrices={levelPrices}
                                                userId={this.state.userId}
                                                isId1WalletConnected={this.state.isId1WalletConnected}
                                                isAuthorized={this.state.isAuthorized}
                                                claimedAndUnclaimedSlots={this.state.claimedAndUnclaimedSlots}
                                                onSlotClick={this.props.onSlotClick}
                                                onBuyLevel={this.handleBuyLevel}
                                                isActive={isActive}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
export default withWrapper(Dashboard);